import React, { useState, useEffect } from 'react';
import './AuthModal.css';

const AuthModal = ({ isOpen, mode, onClose, onSwitchMode, onSubmit, loading, error }) => {
    const [formData, setFormData] = useState({
        username: '',
        email: '',
        password: '',
    });

    useEffect(() => {
        if (!isOpen) {
            setFormData({ username: '', email: '', password: '' });
        }
    }, [isOpen, mode]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData, () => setFormData({ username: '', email: '', password: '' }));
    };

    if (!isOpen) return null;

    return (
        <div className="auth-modal-overlay" role="dialog" aria-modal="true">
            <div className="auth-modal">
                <button className="auth-modal-close" onClick={onClose} aria-label="Close authentication dialog">
                    ✕
                </button>
                <h2 className="auth-modal-title">{mode === 'login' ? 'Log In' : 'Create Account'}</h2>
                <p className="auth-modal-subtitle">
                    {mode === 'login'
                        ? 'Welcome back! Log in to share your matcha experiences.'
                        : 'Join MatchaMap to share your matcha adventures.'}
                </p>

                <form className="auth-form" onSubmit={handleSubmit}>
                    <div className="auth-form-group">
                        <label htmlFor="username">Email</label>
                        <input
                            id="username"
                            name="username"
                            type="text"
                            value={formData.username}
                            onChange={handleChange}
                            required
                            placeholder="Your email"
                        />
                    </div>

                    {mode === 'register' && (
                        <div className="auth-form-group">
                            <label htmlFor="email">Email</label>
                            <input
                                id="email"
                                name="email"
                                type="email"
                                value={formData.email}
                                onChange={handleChange}
                                placeholder="you@example.com"
                            />
                        </div>
                    )}

                    <div className="auth-form-group">
                        <label htmlFor="password">Password</label>
                        <input
                            id="password"
                            name="password"
                            type="password"
                            value={formData.password}
                            onChange={handleChange}
                            required
                            minLength={6}
                            placeholder="Enter password"
                        />
                    </div>

                    {error && <p className="auth-error">{error}</p>}

                    <button className="auth-submit" type="submit" disabled={loading}>
                        {loading ? 'Please wait...' : mode === 'login' ? 'Log In' : 'Register'}
                    </button>
                </form>

                <div className="auth-switch">
                    {mode === 'login' ? (
                        <p>
                            Need an account?{' '}
                            <button type="button" onClick={() => onSwitchMode('register')}>
                                Create one
                            </button>
                        </p>
                    ) : (
                        <p>
                            Already have an account?{' '}
                            <button type="button" onClick={() => onSwitchMode('login')}>
                                Log in
                            </button>
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AuthModal;
